module.exports = __webpack_public_path__ + "img/GAME_POND.87c56b9a.png";